/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ wpm: NonNullable<unknown> }} Event_Warning_Wpm_TitleInputs */



/**
* | output |
* | --- |
* | "WPM warning: WPM ({wpm}) is above max value" |
*
* @param {Event_Warning_Wpm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_wpm_title = /** @type {((inputs: Event_Warning_Wpm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Wpm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Alerte MPM : le MPM (${i?.wpm}) dépasse la valeur maximale`)
	if (locale === "de") return /** @type {LocalizedString} */ (`WPM-Warnung: WPM (${i?.wpm}) liegt über dem Maximalwert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Avviso WPM: WPM (${i?.wpm}) è superiore al valore massimo`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Предупреждение: скорость печати (${i?.wpm}) превышает максимальное значение.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Advertencia de WPM: WPM (${i?.wpm}) está por encima del valor máximo`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`WPM 警告：WPM (${i?.wpm}) 超过最大值`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`WPM警告: WPM (${i?.wpm}) が最大値を超えています`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`WPM चेतावनी: WPM (${i?.wpm}) अधिकतम मान से अधिक है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Aviso de WPM: WPM (${i?.wpm}) está acima do valor máximo.`)
	return /** @type {LocalizedString} */ (`WPM warning: WPM (${i?.wpm}) is above max value`)
});